import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'
import {
  NotificationGetResponseSchema,
  NotificationListResponseSchema,
  NotificationsUnreadResponseSchema,
} from '@/schemas/v2'
import type { NotificationGetResponse, NotificationListResponse, NotificationsUnreadResponse } from '@/schemas/v2'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

export async function fetchNotifications(options?: FetchOptions): Promise<NotificationListResponse> {
  const url = `${BASE}/api/v2/notifications`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return NotificationListResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchNotification(id: number, options?: FetchOptions): Promise<NotificationGetResponse> {
  const url = `${BASE}/api/v2/notifications/${id}`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return NotificationGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

export async function fetchNotificationsUnread(options?: FetchOptions): Promise<NotificationsUnreadResponse> {
  const url = `${BASE}/api/v2/notifications/unread`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return NotificationsUnreadResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}
